/**
 * http://usejsdoc.org/
 */
import { create } from 'apisauce';
import authStore from '../stores/auth-store';
import urlgetter from './getMainUrl';

const api = create({
	baseURL: urlgetter.getMainApiUrl()
});

const func = {};

func.loadAllJumpers = () =>{
	//console.log('in loadAllJumpers');
  var token = authStore.getAuthToken();
  if(token == '')
  {
     token = localStorage.getItem("Auth-token");
  }
  //console.log(token);
  api.setHeader('Authorization', 'Bearer ' + token)
  return api.get('/jumpers');
}

func.initializeLocalJumpers = () => {
	//console.log('in initializeLocalJumpers');
	var token = authStore.getAuthToken();
	if(token == '')
	{
	   token = localStorage.getItem("Auth-token");
	}
	//console.log(token);
	api.setHeader('Authorization', 'Bearer ' + token)
    return api.get('/jumpers/initLocal');
}


export default func;